module.exports = __webpack_public_path__ + "static/media/logo.5b2f1e12.png";